"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _axios = _interopRequireDefault(require("axios"));

var _bluebird = _interopRequireDefault(require("bluebird"));

var _lodash = _interopRequireDefault(require("lodash"));

var _uuid = _interopRequireDefault(require("uuid"));

var _basic_data_hub_api = _interopRequireDefault(require("./basic_data_hub_api"));

var _constants = require("./lib/constants");

var _utils = require("./lib/utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defaultLambdaMemorySize = 1024;
var defaultLambdaTimeout = 30;

var FlowsApi =
/*#__PURE__*/
function (_BasicDataHubApi) {
  (0, _inherits2.default)(FlowsApi, _BasicDataHubApi);

  /**
   * @constructor
   */
  function FlowsApi(_ref) {
    var _this;

    var dataHubUrl = _ref.dataHubUrl,
        userTokenFactory = _ref.userTokenFactory,
        onGraphQLErrors = _ref.onGraphQLErrors,
        onNetworkError = _ref.onNetworkError,
        deployerUrl = _ref.deployerUrl,
        sdkApiUrl = _ref.sdkApiUrl,
        accountId = _ref.accountId,
        defaultLimit = _ref.defaultLimit,
        accountIdFactory = _ref.accountIdFactory;
    (0, _classCallCheck2.default)(this, FlowsApi);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FlowsApi).call(this, {
      dataHubUrl: dataHubUrl,
      userTokenFactory: userTokenFactory,
      onGraphQLErrors: onGraphQLErrors,
      onNetworkError: onNetworkError,
      accountId: accountId,
      defaultLimit: defaultLimit,
      accountIdFactory: accountIdFactory
    }));
    _this.sdkApiUrl = sdkApiUrl;
    _this.deployerUrl = deployerUrl;
    return _this;
  }

  (0, _createClass2.default)(FlowsApi, [{
    key: "activateFlow",
    value: function () {
      var _activateFlow = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(flow, progresCallback) {
        var flowAlias, headers, _ref2, requestId;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                flowAlias = "v-".concat(Date.now());
                _context.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context.sent;
                _context.next = 6;
                return _axios.default.post(this.deployUrl, {
                  flowId: flow.id,
                  flowAlias: flowAlias,
                  interactiveDebug: flow.interactiveDebug,
                  role: _lodash.default.get(flow, 'data.deploy.role')
                }, headers);

              case 6:
                _ref2 = _context.sent;
                requestId = _ref2.data.requestId;
                return _context.abrupt("return", this._pollResult(flow.id, requestId, headers, progresCallback));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function activateFlow(_x, _x2) {
        return _activateFlow.apply(this, arguments);
      }

      return activateFlow;
    }()
  }, {
    key: "deactivateFlow",
    value: function () {
      var _deactivateFlow = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(flow, flowAlias) {
        var deleteLambda,
            headers,
            requestParams,
            _ref3,
            requestId,
            _args2 = arguments;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                deleteLambda = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;
                _context2.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context2.sent;
                requestParams = _lodash.default.merge({
                  data: {
                    flow: {
                      id: flow.id
                    },
                    flowAlias: flowAlias,
                    role: _lodash.default.get(flow, 'data.deploy.role'),
                    deleteLambda: deleteLambda
                  },
                  headers: {
                    'Content-Type': 'application/json;charset=UTF-8'
                  }
                }, headers);
                _context2.next = 7;
                return _axios.default.delete(this.deployUrl, requestParams);

              case 7:
                _ref3 = _context2.sent;
                requestId = _ref3.data.requestId;
                return _context2.abrupt("return", this._pollResult(flow.id, requestId, headers));

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function deactivateFlow(_x3, _x4) {
        return _deactivateFlow.apply(this, arguments);
      }

      return deactivateFlow;
    }()
  }, {
    key: "deleteFlow",
    value: function () {
      var _deleteFlow = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(flow) {
        var flowAlias,
            temporarily,
            binding,
            method,
            accountId,
            _ref4,
            requestId,
            _args3 = arguments;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                flowAlias = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 'dev';
                temporarily = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : true;
                _context3.next = 4;
                return this.getBinding();

              case 4:
                binding = _context3.sent;
                method = this._getMethodName(temporarily ? 'deleteTemporarily' : 'delete');
                accountId = this.accountId;
                _context3.next = 9;
                return binding.mutation[method](_objectSpread({
                  entity: _constants.FLOW,
                  data: {
                    id: flow.id,
                    flowAlias: flowAlias,
                    subscribe: true,
                    role: _lodash.default.get(flow, 'data.deploy.role')
                  }
                }, accountId ? {
                  accountId: accountId
                } : {}));

              case 9:
                _ref4 = _context3.sent;
                requestId = _ref4.requestId;
                return _context3.abrupt("return", this.subscribe(requestId));

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function deleteFlow(_x5) {
        return _deleteFlow.apply(this, arguments);
      }

      return deleteFlow;
    }()
  }, {
    key: "recoverFlow",
    value: function () {
      var _recoverFlow = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(flow) {
        var flowAlias,
            binding,
            method,
            accountId,
            _args4 = arguments;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                flowAlias = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : 'dev';
                _context4.next = 3;
                return this.getBinding();

              case 3:
                binding = _context4.sent;
                method = this._getMethodName('recover');
                accountId = this.accountId;
                return _context4.abrupt("return", binding.mutation[method](_objectSpread({
                  entity: _constants.FLOW,
                  data: {
                    id: flow.id,
                    flowAlias: flowAlias,
                    role: _lodash.default.get(flow, 'data.deploy.role')
                  }
                }, accountId ? {
                  accountId: accountId
                } : {})));

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function recoverFlow(_x6) {
        return _recoverFlow.apply(this, arguments);
      }

      return recoverFlow;
    }() // lockFlow ({id, force}) {
    //     return Promise.try(() => Vue.http.get(`${this.flowsLockUrl}/${id}`, _.merge({params : {force}}, this.headers)))
    //         .then(response => response.json());
    // }

  }, {
    key: "getFlowById",
    value: function () {
      var _getFlowById = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(id, projection) {
        var sandbox,
            _args5 = arguments;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                sandbox = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : false;
                return _context5.abrupt("return", this._callApi({
                  path: "/v2/".concat(this.accountIdFactory, "/flow/").concat(id),
                  queryParams: {
                    projection: projection,
                    includeDeleted: false,
                    includeExisting: true,
                    sandbox: sandbox
                  }
                }));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getFlowById(_x7, _x8) {
        return _getFlowById.apply(this, arguments);
      }

      return getFlowById;
    }()
  }, {
    key: "getFlows",
    value: function () {
      var _getFlows = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(_ref5) {
        var _ref5$query, query, projection, _ref5$includeDeleted, includeDeleted, _ref5$includeExisting, includeExisting, sandbox, result, last, responce;

        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _ref5$query = _ref5.query, query = _ref5$query === void 0 ? {} : _ref5$query, projection = _ref5.projection, _ref5$includeDeleted = _ref5.includeDeleted, includeDeleted = _ref5$includeDeleted === void 0 ? false : _ref5$includeDeleted, _ref5$includeExisting = _ref5.includeExisting, includeExisting = _ref5$includeExisting === void 0 ? true : _ref5$includeExisting, sandbox = _ref5.sandbox;
                result = [];

              case 2:
                query.last = last;
                _context6.next = 5;
                return this._callApi({
                  path: "/v2/".concat(this.accountIdFactory, "/flows"),
                  queryParams: {
                    projection: projection,
                    includeDeleted: includeDeleted,
                    includeExisting: includeExisting,
                    query: _objectSpread({}, query, {}, query.id ? {
                      id: _lodash.default.split(query.id, ',')
                    } : {}),
                    sandbox: sandbox
                  }
                });

              case 5:
                responce = _context6.sent;
                result = result.concat(responce.items);
                last = responce.last;

              case 8:
                if (last) {
                  _context6.next = 2;
                  break;
                }

              case 9:
                return _context6.abrupt("return", result);

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getFlows(_x9) {
        return _getFlows.apply(this, arguments);
      }

      return getFlows;
    }()
  }, {
    key: "getFlowsByToken",
    value: function () {
      var _getFlowsByToken = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(_ref6) {
        var _ref6$query, query, projection, limit, token, binding, method, accountId;

        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _ref6$query = _ref6.query, query = _ref6$query === void 0 ? {} : _ref6$query, projection = _ref6.projection, limit = _ref6.limit, token = _ref6.token;
                _context7.next = 3;
                return this.getBinding();

              case 3:
                binding = _context7.sent;
                method = this._getMethodName('list');
                accountId = this.accountId;
                return _context7.abrupt("return", binding.query[method](_objectSpread({
                  entity: _constants.FLOW,
                  params: {
                    ids: query.id ? _lodash.default.split(query.id, ',') : undefined,
                    queryParams: query,
                    limit: limit,
                    last: token
                  }
                }, accountId ? {
                  accountId: accountId
                } : {}), projection || ['records', 'last']));

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getFlowsByToken(_x10) {
        return _getFlowsByToken.apply(this, arguments);
      }

      return getFlowsByToken;
    }()
  }, {
    key: "getFlowsWithTags",
    value: function () {
      var _getFlowsWithTags = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee8(_ref7) {
        var _ref7$query, query, projection, binding, method, accountId;

        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _ref7$query = _ref7.query, query = _ref7$query === void 0 ? {} : _ref7$query, projection = _ref7.projection;
                _context8.next = 3;
                return this.getBinding();

              case 3:
                binding = _context8.sent;
                method = this._getMethodName('listWithTags');
                accountId = this.accountId;
                return _context8.abrupt("return", binding.query[method](_objectSpread({
                  entity: _constants.FLOW,
                  params: {
                    ids: query.id ? _lodash.default.split(query.id, ',') : undefined,
                    queryParams: query
                  }
                }, accountId ? {
                  accountId: accountId
                } : {}), projection));

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getFlowsWithTags(_x11) {
        return _getFlowsWithTags.apply(this, arguments);
      }

      return getFlowsWithTags;
    }()
  }, {
    key: "listFlowsByStepTemplate",
    value: function () {
      var _listFlowsByStepTemplate = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee9(_ref8) {
        var _ref8$query, query, stepTemplateId, projection, _ref8$includesStep, includesStep;

        return _regenerator.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _ref8$query = _ref8.query, query = _ref8$query === void 0 ? {} : _ref8$query, stepTemplateId = _ref8.stepTemplateId, projection = _ref8.projection, _ref8$includesStep = _ref8.includesStep, includesStep = _ref8$includesStep === void 0 ? false : _ref8$includesStep;
                return _context9.abrupt("return", this._getPaginatedList('listFlowsByStepTemplate', {
                  entity: _constants.FLOW,
                  params: {
                    ids: query.id ? _lodash.default.split(query.id, ',') : undefined,
                    queryParams: _objectSpread({}, query, {
                      stepTemplateId: stepTemplateId
                    })
                  },
                  includesStep: includesStep,
                  accountId: this.accountId || this.accountIdFactory
                }, projection));

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function listFlowsByStepTemplate(_x12) {
        return _listFlowsByStepTemplate.apply(this, arguments);
      }

      return listFlowsByStepTemplate;
    }()
  }, {
    key: "getFlowsByBotId",
    value: function getFlowsByBotId(botId, projection) {
      return this.getFlows({
        query: {
          botId: botId
        },
        projection: projection
      });
    }
  }, {
    key: "getFlowsWithTagsByBotId",
    value: function getFlowsWithTagsByBotId(botId, projection) {
      return this.getFlowsWithTags({
        query: {
          botId: botId
        },
        projection: projection
      });
    }
  }, {
    key: "getFlowEvents",
    value: function () {
      var _getFlowEvents = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee10(_ref9) {
        var _this2 = this;

        var flowId, _ref9$alias, alias, headers;

        return _regenerator.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                flowId = _ref9.flowId, _ref9$alias = _ref9.alias, alias = _ref9$alias === void 0 ? 'prod' : _ref9$alias;
                _context10.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context10.sent;
                return _context10.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get("".concat(_this2.sdkApiUrl, "/event-manager/get-flow-events/").concat(flowId, "/").concat(alias), headers);
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getFlowEvents(_x13) {
        return _getFlowEvents.apply(this, arguments);
      }

      return getFlowEvents;
    }()
    /**
        * function that gets list of flows that subscribed on certain triggers
        * @param {Array} triggers   list of triggers the active flows should be returned for
        trigger should have format like
            [
                {
                    name: {String},
                    params: {},
                    target: {String}'
                },
            ]
        * @returns {Array} of the same troggers with 'flows' keys inside
    */

  }, {
    key: "getTriggerFlows",
    value: function () {
      var _getTriggerFlows = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee11() {
        var _this3 = this;

        var triggers,
            headers,
            _args11 = arguments;
        return _regenerator.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                triggers = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : [];
                _context11.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context11.sent;
                return _context11.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.post("".concat(_this3.sdkApiUrl, "/event-manager/get-trigger-flows"), {
                    triggers: triggers
                  }, headers);
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getTriggerFlows() {
        return _getTriggerFlows.apply(this, arguments);
      }

      return getTriggerFlows;
    }()
  }, {
    key: "listVersions",
    value: function () {
      var _listVersions = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee12(_ref10) {
        var flowId, binding, method, accountId;
        return _regenerator.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                flowId = _ref10.flowId;
                _context12.next = 3;
                return this.getBinding();

              case 3:
                binding = _context12.sent;
                method = this._getMethodName('listVersions');
                accountId = this.accountId;
                return _context12.abrupt("return", binding.query[method](_objectSpread({
                  entity: _constants.FLOW,
                  params: {
                    id: flowId
                  }
                }, accountId ? {
                  accountId: accountId
                } : {})));

              case 7:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function listVersions(_x14) {
        return _listVersions.apply(this, arguments);
      }

      return listVersions;
    }()
  }, {
    key: "getVersion",
    value: function () {
      var _getVersion = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee13(_ref11) {
        var flowId, version, binding, method, accountId;
        return _regenerator.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                flowId = _ref11.flowId, version = _ref11.version;
                _context13.next = 3;
                return this.getBinding();

              case 3:
                binding = _context13.sent;
                method = this._getMethodName('getVersion');
                accountId = this.accountId;
                return _context13.abrupt("return", binding.query[method](_objectSpread({
                  entity: _constants.FLOW,
                  params: {
                    id: flowId
                  }
                }, accountId ? {
                  accountId: accountId
                } : {}, {
                  version: version
                })));

              case 7:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function getVersion(_x15) {
        return _getVersion.apply(this, arguments);
      }

      return getVersion;
    }()
  }, {
    key: "listFlowVersionsByBotId",
    value: function () {
      var _listFlowVersionsByBotId = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee14(_ref12) {
        var botId, binding;
        return _regenerator.default.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                botId = _ref12.botId;
                _context14.next = 3;
                return this.getBinding();

              case 3:
                binding = _context14.sent;
                return _context14.abrupt("return", binding.query.listFlowVersionsByBotId({
                  botId: botId
                }));

              case 5:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function listFlowVersionsByBotId(_x16) {
        return _listFlowVersionsByBotId.apply(this, arguments);
      }

      return listFlowVersionsByBotId;
    }()
  }, {
    key: "loadLogs",
    value: function () {
      var _loadLogs = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee15(_ref13) {
        var flowId, next, startTime, endTime, limit, filter, relativeTime, headers, logsUrl, queryParams;
        return _regenerator.default.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                flowId = _ref13.flowId, next = _ref13.next, startTime = _ref13.startTime, endTime = _ref13.endTime, limit = _ref13.limit, filter = _ref13.filter, relativeTime = _ref13.relativeTime;
                _context15.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context15.sent;
                logsUrl = "".concat(this.deployerUrl, "/flows/").concat(flowId, "/logs");
                queryParams = {
                  skipOriginal: true
                };

                if (next) {
                  queryParams.next = next;
                }

                if (startTime) {
                  queryParams.start = startTime;
                }

                if (endTime) {
                  queryParams.end = endTime;
                }

                if (limit) {
                  queryParams.limit = limit;
                }

                if (filter) {
                  queryParams.filter = filter;
                }

                if (relativeTime) {
                  queryParams.relativeTime = relativeTime;
                }

                return _context15.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get(logsUrl, _lodash.default.merge({
                    params: queryParams
                  }, headers));
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }).then(function (responseJson) {
                  if (_lodash.default.has(responseJson, 'errorMessage')) {
                    throw responseJson;
                  }

                  return responseJson;
                }));

              case 13:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function loadLogs(_x17) {
        return _loadLogs.apply(this, arguments);
      }

      return loadLogs;
    }()
  }, {
    key: "saveFlow",
    value: function () {
      var _saveFlow = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee16(flow) {
        var _ref14,
            previousVersion,
            _args16 = arguments;

        return _regenerator.default.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _ref14 = _args16.length > 1 && _args16[1] !== undefined ? _args16[1] : {}, previousVersion = _ref14.previousVersion;
                return _context16.abrupt("return", this._callApi({
                  path: "/v2/".concat(this.accountIdFactory, "/flow/").concat(flow.id || 'new'),
                  payload: {
                    flow: flow,
                    previousVersion: previousVersion
                  },
                  method: 'post'
                }));

              case 2:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function saveFlow(_x18) {
        return _saveFlow.apply(this, arguments);
      }

      return saveFlow;
    }()
  }, {
    key: "getRemoteDataOutsByBotId",
    value: function () {
      var _getRemoteDataOutsByBotId = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee17(id) {
        var botFLows;
        return _regenerator.default.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.getFlowsByBotId(id, ['id', 'data.label', 'data.meta.sharedDataOuts', 'data.meta.dataOuts']);

              case 2:
                botFLows = _context17.sent;
                return _context17.abrupt("return", _lodash.default.reduce(botFLows, function (acc, flow) {
                  var flowLabel = _lodash.default.get(flow, 'data.label', 'No name flow');

                  var dataOuts = _lodash.default.reject(_lodash.default.get(flow, 'data.meta.dataOuts'), function (dataOut) {
                    return dataOut.type === 'session' || _lodash.default.isEmpty(dataOut.name) || _lodash.default.isEmpty(dataOut.type);
                  });

                  acc[flow.id] = _lodash.default.map(dataOuts, function (dataOut) {
                    return _objectSpread({}, dataOut, {
                      botId: id,
                      flowId: flow.id,
                      flowLabel: flowLabel
                    });
                  });
                  return acc;
                }, {}));

              case 4:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function getRemoteDataOutsByBotId(_x19) {
        return _getRemoteDataOutsByBotId.apply(this, arguments);
      }

      return getRemoteDataOutsByBotId;
    }()
  }, {
    key: "_pollResult",
    value: function () {
      var _pollResult2 = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee18(flowId, requestId, headers, progresCallback) {
        var counter, _ref15, result;

        return _regenerator.default.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                counter = 0;

              case 1:
                counter++;
                _context18.next = 4;
                return _bluebird.default.delay(1000);

              case 4:
                _context18.next = 6;
                return _axios.default.get("".concat(this.checkUrl, "/").concat(flowId, "/").concat(requestId), headers).catch(function (e) {
                  throw new Error((0, _utils.parseAxiosError)(e));
                });

              case 6:
                _ref15 = _context18.sent;
                result = _ref15.data;

                if (_lodash.default.isFunction(progresCallback)) {
                  progresCallback(result);
                }

                if (!(result.status !== 'pending')) {
                  _context18.next = 13;
                  break;
                }

                if (!result.errorData) {
                  _context18.next = 12;
                  break;
                }

                throw result;

              case 12:
                return _context18.abrupt("return", result);

              case 13:
                if (counter < 100) {
                  _context18.next = 1;
                  break;
                }

              case 14:
                throw new Error('Activation duration is too long');

              case 15:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function _pollResult(_x20, _x21, _x22, _x23) {
        return _pollResult2.apply(this, arguments);
      }

      return _pollResult;
    }() // unlockFlow ({id, lockId}) {
    //     return Promise.try(() => Vue.http.delete(`${this.flowsLockUrl}/${id}`, _.merge({params : {lockId}}, this.headers)))
    //         .then(response => response.json());
    // }

  }, {
    key: "deployUrl",
    get: function get() {
      return this.accountId ? "".concat(this.deployerUrl, "/accounts/").concat(this.accountId, "/flows/deploy") : "".concat(this.deployerUrl, "/flows/deploy");
    }
  }, {
    key: "checkUrl",
    get: function get() {
      return this.accountId ? "".concat(this.deployerUrl, "/accounts/").concat(this.accountId, "/flows/check") : "".concat(this.deployerUrl, "/flows/check");
    }
  }], [{
    key: "getEmptyStep",
    value: function getEmptyStep(stepId) {
      return {
        id: stepId || _uuid.default.v4(),
        icon: 'add',
        iconType: 'default',
        iconUrl: '',
        shape: 'empty',
        type: 'empty',
        pinLabel: true,
        stepInputData: {}
      };
    }
  }, {
    key: "getEmptyFlow",
    value: function getEmptyFlow(botId) {
      return {
        botId: botId,
        data: {
          label: '',
          description: '',
          deploy: {
            memory: defaultLambdaMemorySize,
            timeout: defaultLambdaTimeout,
            role: 'USER'
          },
          meta: {},
          color: null,
          categories: null,
          annotations: null,
          stepTemplates: [],
          trees: {
            main: {
              position: {
                x: 0,
                y: 0
              },
              steps: [this.getEmptyStep()]
            }
          }
        }
      };
    }
  }, {
    key: "getNewFlow",
    value: function () {
      var _getNewFlow = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee19(botId, flowTemplate) {
        var flow, template;
        return _regenerator.default.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                flow = this.getEmptyFlow(botId);
                template = _lodash.default.omit(flowTemplate, ['id', 'botId', 'dateCreated', 'dateModified', 'version']); // if template has any steps then remove default empty step
                // or leave it otherwise

                flow.data.steps = _lodash.default.get(template, 'data.steps.length') > 0 ? [] : flow.data.steps; // merge step with flow template

                return _context19.abrupt("return", _lodash.default.merge(flow, template));

              case 4:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function getNewFlow(_x24, _x25) {
        return _getNewFlow.apply(this, arguments);
      }

      return getNewFlow;
    }()
  }]);
  return FlowsApi;
}(_basic_data_hub_api.default);

var _default = FlowsApi;
exports.default = _default;